<template>
	<v-dialog
		v-model="fileMetaEditorDialog"
		fullscreen
		scrollable
		hide-overlay
		transition="dialog-bottom-transition"
		persistent
	>
		<v-card>
			<v-toolbar>
				<v-btn icon @click="closeFileMetaDialog">
					<v-icon>close</v-icon>
				</v-btn>
				<div>
					<v-toolbar-title>
						{{ selectedFile.stockistName }} -
						{{ selectedFile.filename }}
					</v-toolbar-title>
					<div v-if="selectedFile && selectedFile.subject">
						{{ selectedFile.subject }} ( {{ selectedFile.sender }} )
					</div>
				</div>
				<template v-slot:extension>
					<v-tabs v-model="model" slider-color="yellow" align-with-title grow>
						<v-tab v-for="i in tabItems" :key="i.tabId" :href="`#${i.tabId}`">{{
							i.name
						}}</v-tab>
					</v-tabs>
				</template>
			</v-toolbar>
			<v-tabs-items v-model="model">
				<v-tab-item v-for="i in tabItems" :key="i.tabId" :value="i.tabId">
					<v-card flat>
						<v-card-text>
							<component
								:dataProp="i.props"
								v-bind:is="i.component"
								v-bind="{
									...i.props,
								}"
							/>
						</v-card-text>
					</v-card>
				</v-tab-item>
			</v-tabs-items>
		</v-card>
	</v-dialog>
</template>

<script>
import FileViewer from './fileViewer';
import JSONViewer from './jsonViewer';
import ExtractedDataViewer from './extractedDataViewer';
import AiFileMetaViewer from './aiFileMetaViewer';
import mailMetaMixin from '../../mixins/mailMetaMixin';
import orignalFileViewerMixin from '../../mixins/orignalFileViewerMixin';
import { mapGetters, mapMutations } from 'vuex';
export default {
	components: {
		FileViewer,
		JSONViewer,
		ExtractedDataViewer,
		AiFileMetaViewer,
	},
	mixins: [mailMetaMixin, orignalFileViewerMixin],
	data() {
		return {
			tabItems: [
				{
					name: 'Current File',
					tabId: 'tab-1',
					component: 'FileViewer',
					props: {},
				},
				{
					name: 'Transformed',
					tabId: 'tab-3',
					component: 'JSONViewer',
					props: {
						renderMode: 'transformed',
					},
				},
				{
					name: 'Extracted Data',
					tabId: 'tab-4',
					component: 'ExtractedDataViewer',
					props: {},
				},
				{
					name: 'File Meta',
					tabId: 'tab-5',
					component: 'AiFileMetaViewer',
					props: {},
				},
			],
			model: 'tab-4',
		};
	},
	methods: {
		...mapMutations('aiMetaMap', ['closeFileMetaDialog']),
	},
	computed: {
		...mapGetters('aiMetaMap', ['fileMetaEditorDialog', 'selectedFile']),
	},
	watch: {
		selectedFile(newVal) {
			if (newVal && newVal._id) {
				this.model = 'tab-4';
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.v-card__text {
	padding: 0px;
}
</style>
